import { QueryClient } from "@tanstack/react-query";
import { fetchBuildStepJobs as fetchBuildStepJobsQuery } from "~/components/build/Show/lib/queries";
import { Step } from "~/lib/pipeline";
import { Job, Build } from "~/components/build/Show/lib/types";

/**
 * Fetch jobs associated with a step that switches behavior based on the progressive build feature flag.
 */
export async function fetchBuildStepJobs<T extends Job>(
  queryClient: QueryClient,
  step: Step,
  build: Build,
): Promise<T[]> {
  if (Features.ProgressiveBuildShow) {
    const res = await queryClient.fetchQuery({
      queryKey: ["build", build.number, "steps", step.uuid, "jobs"],
      queryFn: () =>
        fetchBuildStepJobsQuery<T>({
          buildDataBasePath: build.buildDataBasePath,
          stepUuid: step.uuid,
        }),
    });

    return res;
  }
  const jobs = build.jobs.filter((job) => job.stepUuid === step.uuid);
  return Promise.resolve(jobs as T[]);
}
